import steps from '@/data/steps'

const state = {
	all: [...steps],
	currentStep: steps[0],
	transitionName: 'slide-left',
	formData: {},
}

const getters = {
	currentStep: (state) => {
		return state.currentStep
	},
}

const actions = {
	goNext({ state, commit, getters }, formData = null) {
		if (formData) {
			commit('SET_FORM_DATA', formData)
		}
		commit('SET_CURRENT_TRANSITION_NAME', 'slide-left')
		commit('SET_CURRENT_STEP', {
			payload: state.all[getters.currentStep.step],
			actionType: 'next',
		})
	},
	goPrevious({ state, commit, getters }) {
		commit('SET_CURRENT_TRANSITION_NAME', 'slide-right')
		commit('SET_CURRENT_STEP', {
			payload: state.all[getters.currentStep.step - 2],
			actionType: 'previous',
		})
	},
}

const mutations = {
	SET_CURRENT_STEP(state, { payload, actionType }) {
		if (actionType === 'next') state.all[payload.step - 2].status = 'complete'
		state.all[payload.step - 1].status = 'current'
		if (actionType === 'previous') state.all[payload.step].status = 'upcoming'
		state.currentStep = state.all[payload.step - 1]
	},
	SET_CURRENT_TRANSITION_NAME(state, name) {
		state.transitionName = name
	},
	SET_FORM_DATA(state, payload) {
		state.formData = { ...state.formData, ...payload }
	},
}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
